import NewArrivalProductList from './NewArrivalProductList'

export default NewArrivalProductList
